import React, { forwardRef, useImperativeHandle, useState } from "react";

import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import { useStripe } from "@stripe/react-stripe-js";
import { useDispatch, useSelector } from "react-redux";

import { StripeWrapper } from "../../../../components";
import { alertActions, checkoutActions } from "../../../../store/actions";
import { SolidSuccessIcon, SuccessIcon } from "../../../../components/Icons";
import { Box } from "@mui/material";

const ACHForm = forwardRef((props, ref) => {
    const stripe = useStripe();
    const dispatch = useDispatch();

    const [cardDetails, setCardDetails] = useState();
    const [clientSecret, setClientSecret] = useState();

    const donationDetails = useSelector(state => state.donationCheckout)

    useImperativeHandle(ref, () => ({
        async collectBankCardForPayment(clientSecretParam) {
            try {
                const paymentIntent = await stripe.collectBankAccountForPayment({
                    clientSecret: clientSecretParam,
                    params: {
                        payment_method_type: "us_bank_account",
                        payment_method_data: {
                            billing_details: {
                                name: donationDetails.userContactDetails.firstName,
                                email: donationDetails.userContactDetails.email,
                            },
                        },
                    },
                    expand: ["payment_method"],
                })

                if (paymentIntent.paymentIntent?.payment_method) {
                    setCardDetails(paymentIntent.paymentIntent);
                    setClientSecret(clientSecretParam)
                    return paymentIntent;
                }

                else {
                    dispatch(checkoutActions.resetCheckoutPaymentMethod());
                    dispatch(alertActions.error("Something went wrong, try selecting the payment again"))
                }
            } catch (error) {
                dispatch(checkoutActions.resetCheckoutPaymentMethod());
                dispatch(alertActions.error("Something went wrong with the payment"))
            }
        },

        async confirmUsBankAccountPayment() {
            try {
                return await stripe.confirmUsBankAccountPayment(clientSecret);
            } catch (error) {
                console.log(error)
            }
        },
    }))

    return <Box className="ACHComponent">
        <Stack className="ACHBankDetails">
            {
                cardDetails?.payment_method ?
                    <>
                        <Typography>
                            {cardDetails.payment_method.us_bank_account.bank_name}
                        </Typography>
                        <Stack className="AccNumClass">
                            <Typography>
                                ******{cardDetails.payment_method.us_bank_account.last4}
                            </Typography>
                            <SolidSuccessIcon />
                        </Stack>
                    </> :
                    <>
                        <Skeleton height={15} width={30} />
                        <Skeleton height={15} width={30} /></>
            }
        </Stack>
    </Box>
})

const StripeACHForm = forwardRef((props, ref) => {
    return (
        props.state.stripePublicKey ?
            <StripeWrapper public_key={props.state.stripePublicKey}>
                <ACHForm ref={ref} />
            </StripeWrapper> : null
    );
})

export default StripeACHForm;